import { Alert } from '@mantine/core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkplace } from '../access';

/** Admin pages; the database refuses the same for everyone else (RLS). */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { t } = useTranslation('dashboard');
  const { access } = useWorkplace();
  return access.isAdmin ? <>{children}</> : <Alert color="yellow">{t('admin.onlyAdmin')}</Alert>;
}
